import { useI18n } from '../i18n';
import styles from './Faq.module.css';

/**
 * The FAQ.
 *
 * Plain headings and paragraphs, not an accordion. Five short answers, so
 * hiding them behind a disclosure would cost a click and a find-in-page match
 * to save no space at all.
 */
export function Faq() {
  const { t } = useI18n();

  return (
    <section className={styles.section} id="faq">
      <p className={`caps ${styles.kicker}`}>{t.faq.kicker}</p>

      <div className={styles.list}>
        {t.faq.items.map((item) => (
          <div key={item.q} className={styles.item}>
            <h3 className={styles.question}>{item.q}</h3>
            <p className={styles.answer}>{item.a}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
